require('./bootstrap');

require('./components/article');
require('./components/catalog-basket');
require('./components/category_filter');
require('./components/main');
require('./components/sidebar');


$(document).ready(function(){
    $("#menu-toggle").click(function(e){
        e.preventDefault();
        $("#wrapper").toggleClass("menuDisplayed");
    });
});
